<template>
  <b-form @submit.prevent>
    <b-form-row>
      <b-form-group label="Wyrażenie" class="mr-3">
        <b-form-input v-model="filters.term" type="text" autocomplete="off" />
      </b-form-group>

      <b-form-group class="mt-auto">
        <b-button type="submit" class="mr-3" variant="primary" @click="onSearch">Szukaj</b-button>
        <b-button type="submit" class="mr-3" variant="secondary" @click="clear">Wyczyść</b-button>
      </b-form-group>
    </b-form-row>
  </b-form>
</template>
<script>
export default {
  data() {
    return {
      filters: {
        term: null
      }
    };
  },
  methods: {
    clear() {
      this.filters.term = null;
    },
    onSearch() {
      this.$emit("filters-search", this.filters);
    }
  }
};
</script>